module.exports = __webpack_public_path__ + "fonts/Graphik-Semibold.03900f56.woff2";